import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { getStatusMessage } from '../../utils/response-code-messages';
import Snackbar from '../../common/snackBar';
import get from 'lodash/get';
import { PartsDataRequestActionTypes, SearchtActionTypes } from '../models/parts-management';
const page_name = 'partManagement';
interface Part {
  id: string | number;
  part_id: string | number;
  machineName: string;
  machineManufacturer: string;
  machineType: string;
  noParts: number;
}

export interface partManagementState {
  isPartManagementDataLoading: boolean;
  partManagementData: Array<Part>;
  machineDetails: any;
  partManagementDataTotalRowCount: number;
  partManagementDataPageNumber: number;
  partManagementError: boolean;
  isAddPartLoading: boolean;
  isAddPartSuccess: boolean;
  isAddPartError: boolean;
  isUpdatePartLoading: boolean;
  isUpdatePartSuccess: boolean;
  isUpdatePartError: boolean;
  isDeletePartLoading: boolean;
  isDeletePartSuccess: boolean;
  isDeletePartError: boolean;
  partManagementMessage: string;
  isBulkUploadPartLoading: boolean;
  isBulkUploadPartSuccess: boolean;
  isBulkUploadPartError: boolean;
  partsStatusCode: number;
  searchItem: undefined | string;
  partPageName:string;
}

const initialState: partManagementState = {
  isPartManagementDataLoading: false,
  partManagementData: [],
  machineDetails: {},
  partManagementDataTotalRowCount: 0,
  partManagementDataPageNumber: 1,
  partManagementError: false,
  isAddPartLoading: false,
  isAddPartSuccess: false,
  isAddPartError: false,
  isUpdatePartLoading: false,
  isUpdatePartSuccess: false,
  isUpdatePartError: false,
  isDeletePartLoading: false,
  isDeletePartSuccess: false,
  isDeletePartError: false,
  partManagementMessage: '',
  isBulkUploadPartLoading: false,
  isBulkUploadPartSuccess: false,
  isBulkUploadPartError: false,
  partsStatusCode: 0,
  searchItem: '',
  partPageName:'Part'
};

const partManagementReducer = createSlice({
  name: page_name,
  initialState: initialState,
  reducers: {
    getPartManagementDataRequest: (state, action: PartsDataRequestActionTypes) => {
      state.isPartManagementDataLoading = true;

      state.isAddPartSuccess = false;
      state.isUpdatePartSuccess = false;
      state.isDeletePartSuccess = false;
      state.partPageName = get(action,'payload.pageName','Part')
    },
    getPartManagementDataResponse: (state, action) => {
      state.isPartManagementDataLoading = false;

      if (state.searchItem === get(action, 'payload.search_item', '')) {
        state.partManagementData = get(action, 'payload.data', []);
        state.machineDetails = get(action, 'payload.machine', {});
        state.partManagementDataTotalRowCount = get(action, 'payload.total_count', []);
        state.partManagementDataPageNumber = get(action, 'payload.page', []);
      }
    },
    getPartManagementDataFailed: (state, action: any) => {
      state.isPartManagementDataLoading = false;
      state.partManagementError = true;
      state.partManagementData = [];

      const message = getStatusMessage(page_name, action.payload);
      state.partManagementMessage = message;
      Snackbar.error(message.replace('Part',state.partPageName));
    },
    addPartRequest: (state) => {
      state.isPartManagementDataLoading = true;
      state.isAddPartLoading = true;
      state.isAddPartSuccess = false;
      state.isAddPartError = false;
    },
    addPartResponse: (state, action: any) => {
      state.isPartManagementDataLoading = false;
      state.isAddPartLoading = false;
      state.isAddPartSuccess = true;

      const message = getStatusMessage(page_name, action.payload);
      state.partManagementMessage = message;
      Snackbar.success(message.replace('Part',state.partPageName));
    },
    addPartFailed: (state, action: any) => {
      state.isPartManagementDataLoading = false;
      state.isAddPartLoading = false;
      state.isAddPartError = true;

      const message = getStatusMessage(page_name, action.payload);
      state.partManagementMessage = message;
      Snackbar.error(message.replace('Part',state.partPageName));
    },
    updatePartRequest: (state) => {
      state.isUpdatePartLoading = true;
      state.isUpdatePartSuccess = false;
      state.isUpdatePartError = false;
    },
    updatePartResponse: (state, action: any) => {
      state.isUpdatePartLoading = false;
      state.isUpdatePartSuccess = true;

      const message = getStatusMessage(page_name, action.payload);
      state.partManagementMessage = message;
      Snackbar.success(message.replace('Part',state.partPageName));
    },
    updatePartFailed: (state, action: any) => {
      state.isUpdatePartLoading = false;
      state.isUpdatePartError = true;

      const message = getStatusMessage(page_name, action.payload);
      state.partManagementMessage = message;
      Snackbar.error(message.replace('Part',state.partPageName));
    },
    deletePartRequest: (state) => {
      state.isPartManagementDataLoading = true;
      state.isDeletePartLoading = true;
      state.isDeletePartSuccess = false;
      state.isDeletePartError = false;
    },
    deletePartResponse: (state, action: any) => {
      state.isPartManagementDataLoading = false;
      state.isDeletePartLoading = false;
      state.isDeletePartSuccess = true;

      const message = getStatusMessage(page_name, action.payload);
      state.partManagementMessage = message;
      Snackbar.success(message.replace('Part',state.partPageName));
    },
    deletePartFailed: (state, action) => {
      state.isPartManagementDataLoading = false;
      state.isDeletePartLoading = false;
      state.isDeletePartError = true;

      const message = getStatusMessage(page_name, action.payload);
      state.partManagementMessage = message;
      Snackbar.error(message.replace('Part',state.partPageName));
    },
    bulkUploadRequest: (state) => {
      state.isPartManagementDataLoading = true;
      state.isBulkUploadPartLoading = true;
      state.isBulkUploadPartSuccess = false;
      state.isBulkUploadPartError = false;
    },
    bulkUploadResponse: (state, action: PayloadAction<any>) => {
      state.isPartManagementDataLoading = false;
      state.isBulkUploadPartLoading = false;
      state.isBulkUploadPartSuccess = true;

      const message = getStatusMessage(page_name, action.payload);
      state.partManagementMessage = message;
      Snackbar.success(message.replace('Part',state.partPageName));
    },
    bulkUploadFailed: (state, action: PayloadAction<any>) => {
      state.isPartManagementDataLoading = false;
      state.isBulkUploadPartLoading = false;
      state.isBulkUploadPartError = true;

      const message = getStatusMessage(page_name, action.payload);
      state.partManagementMessage = message;
      // Snackbar.error(message);
      Snackbar.error(
        action.payload === '409'
          ? '"PART NAME" already exists, Please specify alternative "PART NAME" in the Template file.'.replace('PART',state.partPageName.toUpperCase())
          : message.replace('Part',state.partPageName)
      );
    },
    resetLoadingState: (state) => {
      state.isPartManagementDataLoading = false;

      state.isAddPartSuccess = false;
      state.isAddPartError = false;

      state.isDeletePartSuccess = false;
      state.isDeletePartError = false;

      state.isUpdatePartSuccess = false;
      state.isUpdatePartError = false;

      state.partManagementMessage = '';
      state.partManagementError = false;

      state.isBulkUploadPartLoading = false;
      state.isBulkUploadPartSuccess = false;
      state.isBulkUploadPartError = true;
      state.partsStatusCode = 0;
    },
    resetPartManagementData: (state) => {
      state.partManagementData = [];
      state.machineDetails = {};
      state.partManagementDataTotalRowCount = 0;
      state.partManagementDataPageNumber = 1;
      state.searchItem = '';
    },
    onSearchForItem: (state, action: SearchtActionTypes) => {
      state.searchItem = action.payload;
    },
  },
});

export const partManagementActions = partManagementReducer.actions;
export default partManagementReducer;
